import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";

export const getPagesEramanPrivilegeCardDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
    TermsAndConditions: [
        {
            fieldName: "Title (EN)",
            fieldValue: "field_page_title_en",
            className: "col-span-6",
            type: "text",
            name: "field_page_title_en",
            formType: "input",
            label: "Title (EN)",
            placeholder: "Enter Title (EN)",
            validation: { required: "Title (EN) is required" },
        },
        {
            fieldName: "Title (MS)",
            fieldValue: "field_page_title_ms",
            className: "col-span-6",
            type: "text",
            name: "field_page_title_ms",
            formType: "input",
            label: "Title (MS)",
            placeholder: "Enter Title (MS)",
            // validation: { required: "Title (MS) is required" },
        },
        {
            fieldName: "Title (ZH)",
            fieldValue: "field_page_title_zh",
            className: "col-span-6",
            type: "text",
            name: "field_page_title_zh",
            formType: "input",
            label: "Title (ZH)",
            placeholder: "Enter Title (ZH)",
            // validation: { required: "Title (ZH) is required" },
        },
        {
            fieldName: "Content (EN)",
            fieldValue: "field_content_description_en",
            className: "col-span-6",
            type: "text",
            name: "field_content_description_en",
            formType: "richText",
            label: "Content (EN)",
            placeholder: "Enter Content (EN)",
            validation: { required: "Content (EN) is required" },
        },
        {
            fieldName: "Content (MS)",
            fieldValue: "field_content_description_ms",
            className: "col-span-6",
            type: "text",
            name: "field_content_description_ms",
            formType: "richText",
            label: "Content (MS)",
            placeholder: "Enter Content (MS)",
            // validation: { required: "Content (MS) is required" },
        },
        {
            fieldName: "Content (ZH)",
            fieldValue: "field_content_description_zh",
            className: "col-span-6",
            type: "text",
            name: "field_content_description_zh",
            formType: "richText",
            label: "Content (ZH)",
            placeholder: "Enter Content (ZH)",
            // validation: { required: "Content (ZH) is required" },
        },
    ],
    Faqs: [
        {
            fieldName: "Sequence No.",
            fieldValue: "field_sequence",
            className: "col-span-6",
            type: "text",
            name: "field_sequence",
            formType: "number",
            label: "Sequence No.",
            placeholder: "Enter Sequence No.",
            validation: { required: "Sequence No. is required" },
        },
        {
            fieldName: "Question (EN)",
            fieldValue: "title",
            className: "col-span-6",
            type: "text",
            name: "title",
            formType: "input",
            label: "Question (EN)",
            placeholder: "Enter Question (EN)",
            validation: { required: "Question (EN) is required" },
        },
        {
            fieldName: "Question (MS)",
            fieldValue: "field_common_malay_title",
            className: "col-span-6",
            type: "text",
            name: "field_common_malay_title",
            formType: "input",
            label: "Question (MS)",
            placeholder: "Enter Question (MS)",
            // validation: { required: "Question (MS) is required" },
        },
        {
            fieldName: "Question (ZH)",
            fieldValue: "field_common_mandarin_title",
            className: "col-span-6",
            type: "text",
            name: "field_common_mandarin_title",
            formType: "input",
            label: "Question (ZH)",
            placeholder: "Enter Question (ZH)",
            // validation: { required: "Question (ZH) is required" },
        },
        {
            fieldName: "Content (EN)",
            fieldValue: "field_content_description_en",
            className: "col-span-6",
            type: "text",
            name: "field_content_description_en",
            formType: "richText",
            label: "Content (EN)",
            placeholder: "Enter Content (EN)",
            validation: { required: "Content (EN) is required" },
        },
        {
            fieldName: "Content (MS)",
            fieldValue: "field_content_description_ms",
            className: "col-span-6",
            type: "text",
            name: "field_content_description_ms",
            formType: "richText",
            label: "Content (MS)",
            placeholder: "Enter Content (MS)",
            // validation: { required: "Content (MS) is required" },
        },
        {
            fieldName: "Content (ZH)",
            fieldValue: "field_content_description_zh",
            className: "col-span-6",
            type: "text",
            name: "field_content_description_zh",
            formType: "richText",
            label: "Content (ZH)",
            placeholder: "Enter Content (ZH)",
            // validation: { required: "Content (ZH) is required" },
        },
        {
            fieldName: "Published",
            fieldValue: "published",
            className: "col-span-12",
            type: "checkbox",
            name: "published",
            formType: "checkbox",
            label: "Published",
            placeholder: "Enter Published",
            // validation: { required: "Publish is required" },a
        }
    ],
};
